module.exports = __webpack_public_path__ + "media/assets/images/logo-movimenta-positivo-0d9f53bca07d3de9ff721f0816cf5b5e.svg";